import React from 'react'

import { Typography, Spinner, Box } from '@vp/swan'
import { useLocalizations } from '@vp/ubik-localizations-provider'

export type PreviewProps = {
  message?: string
}

export const Processing: React.FC<PreviewProps> = ({ message }) => {
  const { t } = useLocalizations()
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100vh',
        width: '100vw',
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridTemplateRows: '1fr',
        gridTemplateAreas: 'progress',
        placeItems: 'center stretch',
        backgroundColor: 'white',
        zIndex: 9999,
      }}
    >
      <Box textAlign="center">
        <Spinner accessibleText={t('loading-label')} showText />
        {message && (
          <Typography mt={7} fontSize="x2large">
            {message}
          </Typography>
        )}
      </Box>
    </div>
  )
}
